"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PessoaEndereco = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const pessoa_entity_1 = require("./pessoa.entity");
let PessoaEndereco = class PessoaEndereco extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdEndereco = void (0);
        this.cdPessoa = void (0);
        this.dsEndereco = void (0);
        this.cdTipoLogradouro = void (0);
        this.cdTipoEndereco = void (0);
        this.cdLogradouro = void (0);
        this.cdBairro = void (0);
        this.cdCidade = void (0);
        this.nmLogradouro = void (0);
        this.nmBairro = void (0);
        this.nrCep = void (0);
        this.nrEndereco = void (0);
        this.nmComplemento = void (0);
        this.nrTelefone = void (0);
        this.nmPontoReferencia = void (0);
        this.lgCobranca = void (0);
        this.lgPrincipal = void (0);
        this.tpZona = void (0);
        this.tpLocalizacaoDiferenciada = void (0);
        this.pessoa = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_endereco", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdEndereco", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_pessoa", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdPessoa", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "ds_endereco", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "dsEndereco", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_tipo_logradouro", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdTipoLogradouro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_tipo_endereco", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdTipoEndereco", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_logradouro", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdLogradouro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_bairro", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdBairro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_cidade", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "cdCidade", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_logradouro", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nmLogradouro", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_bairro", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nmBairro", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_cep", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nrCep", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_endereco", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nrEndereco", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_complemento", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nmComplemento", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_telefone", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nrTelefone", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_ponto_referencia", nullable: true }),
    __metadata("design:type", String)
], PessoaEndereco.prototype, "nmPontoReferencia", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_cobranca", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "lgCobranca", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_principal", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "lgPrincipal", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_zona", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "tpZona", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_localizacao_diferenciada", nullable: true }),
    __metadata("design:type", Number)
], PessoaEndereco.prototype, "tpLocalizacaoDiferenciada", void 0);
__decorate([
    typeorm_1.ManyToOne(type => pessoa_entity_1.Pessoa, pessoa => pessoa.pessoasEnderecos),
    typeorm_1.JoinColumn([{ name: "cd_pessoa", referencedColumnName: "cdPessoa" }]),
    __metadata("design:type", pessoa_entity_1.Pessoa)
], PessoaEndereco.prototype, "pessoa", void 0);
PessoaEndereco = __decorate([
    typeorm_1.Entity('grl_pessoa_endereco')
], PessoaEndereco);
exports.PessoaEndereco = PessoaEndereco;
